import { trigger, state, style, transition, animate, group } from '@angular/animations';

export const FadeInOutAnimation = [
    trigger('fadeInOut', [
        state(
            'in',
            style({
                opacity: '1',
                display: 'block'
            })
        ),
        state(
            'out',
            style({
                opacity: '0',
                display: 'none'
            })
        ),
        transition('* => out', [
            group([
                animate(
                    '700ms ease-out',
                    style({
                        opacity: '0',
                        display: 'none'
                    })
                )
            ])
        ]),
        transition('* => in', [
            group([
                animate(
                    '700ms ease-in',
                    style({
                        opacity: '1'
                    })
                ),
                animate(
                    '1ms ease-in',
                    style({
                        display: 'block' // 'visibility': 'visible'
                    })
                )
            ])
        ])
    ])
];

export const FlipInOutAnimation = [
    trigger('flipInOut', [
        state(
            'in',
            style({
                transform: 'rotateY(180deg)'
            })
        ),
        state(
            'out',
            style({
                transform: 'rotateY(0deg)'
            })
        ),
        transition('* => out', [
            group([
                animate(
                    '700ms ease-in-out',
                    style({
                        opacity: '0',
                        display: 'none'
                    })
                )
                // animate('700ms ease-in-out', style({
                //     'visibility': 'hidden'
                // }))
            ])
        ]),
        transition('* => in', animate('700ms ease-in')),
        transition('* => out', animate('700ms ease-out'))
    ])
];
